(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["../hmodules/components/h-charts/partials/chart-group-lines.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dataGroup")),"lines");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("line", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += " ";
var t_5;
t_5 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0");
frame.set("lineIndex", t_5, true);
if(frame.topLevel) {
context.setVariable("lineIndex", t_5);
}
if(frame.topLevel) {
context.addExport("lineIndex", t_5);
}
output += " ";
var t_6;
t_6 = (runtime.contextOrFrameLookup(context, frame, "groupWidthValue") / 2);
frame.set("xValue", t_6, true);
if(frame.topLevel) {
context.setVariable("xValue", t_6);
}
if(frame.topLevel) {
context.addExport("xValue", t_6);
}
output += " ";
frame = frame.push();
var t_9 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"values")),runtime.contextOrFrameLookup(context, frame, "groupIndex"))),"v");
if(t_9) {t_9 = runtime.fromIterator(t_9);
var t_8 = t_9.length;
for(var t_7=0; t_7 < t_9.length; t_7++) {
var t_10 = t_9[t_7];
frame.set("lineValue", t_10);
frame.set("loop.index", t_7 + 1);
frame.set("loop.index0", t_7);
frame.set("loop.revindex", t_8 - t_7);
frame.set("loop.revindex0", t_8 - t_7 - 1);
frame.set("loop.first", t_7 === 0);
frame.set("loop.last", t_7 === t_8 - 1);
frame.set("loop.length", t_8);
output += " ";
var t_11;
t_11 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.memberLookup((runtime.memberLookup((t_4),"code")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0")))),"axis");
frame.set("axisCode", t_11, true);
if(frame.topLevel) {
context.setVariable("axisCode", t_11);
}
if(frame.topLevel) {
context.addExport("axisCode", t_11);
}
output += " ";
var t_12;
t_12 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"y_axis")),runtime.contextOrFrameLookup(context, frame, "axisCode"))),"maxValue");
frame.set("maxValue", t_12, true);
if(frame.topLevel) {
context.setVariable("maxValue", t_12);
}
if(frame.topLevel) {
context.addExport("maxValue", t_12);
}
output += " ";
var t_13;
t_13 = runtime.memberLookup((runtime.memberLookup((t_4),"code")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"));
frame.set("valueCode", t_13, true);
if(frame.topLevel) {
context.setVariable("valueCode", t_13);
}
if(frame.topLevel) {
context.addExport("valueCode", t_13);
}
output += " ";
var t_14;
t_14 = (runtime.contextOrFrameLookup(context, frame, "innerGroupHeightValue") - ((runtime.memberLookup((t_10),"value") / runtime.contextOrFrameLookup(context, frame, "maxValue")) * runtime.contextOrFrameLookup(context, frame, "innerGroupHeightValue")));
frame.set("yValue", t_14, true);
if(frame.topLevel) {
context.setVariable("yValue", t_14);
}
if(frame.topLevel) {
context.addExport("yValue", t_14);
}
output += " ";
var t_15;
t_15 = runtime.memberLookup((t_10),"circle_color") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.contextOrFrameLookup(context, frame, "valueCode"))),"color");
frame.set("circleColor", t_15, true);
if(frame.topLevel) {
context.setVariable("circleColor", t_15);
}
if(frame.topLevel) {
context.addExport("circleColor", t_15);
}
output += " ";
var t_16;
t_16 = runtime.memberLookup((t_10),"stroke") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.contextOrFrameLookup(context, frame, "valueCode"))),"stroke");
frame.set("circleStroke", t_16, true);
if(frame.topLevel) {
context.setVariable("circleStroke", t_16);
}
if(frame.topLevel) {
context.addExport("circleStroke", t_16);
}
output += " ";
if(runtime.contextOrFrameLookup(context, frame, "groupIndex") > 0 && !runtime.memberLookup((t_10),"hidePreviousPath")) {
output += " ";
var t_17;
t_17 = (runtime.contextOrFrameLookup(context, frame, "groupIndex") - 1);
frame.set("previousIndex", t_17, true);
if(frame.topLevel) {
context.setVariable("previousIndex", t_17);
}
if(frame.topLevel) {
context.addExport("previousIndex", t_17);
}
output += " ";
var t_18;
t_18 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"values")),runtime.contextOrFrameLookup(context, frame, "previousIndex"))),"v")),0);
frame.set("previousLineValue", t_18, true);
if(frame.topLevel) {
context.setVariable("previousLineValue", t_18);
}
if(frame.topLevel) {
context.addExport("previousLineValue", t_18);
}
output += " ";
var t_19;
t_19 = (runtime.contextOrFrameLookup(context, frame, "xValue") - runtime.contextOrFrameLookup(context, frame, "groupWidthValue"));
frame.set("xPreviousValue", t_19, true);
if(frame.topLevel) {
context.setVariable("xPreviousValue", t_19);
}
if(frame.topLevel) {
context.addExport("xPreviousValue", t_19);
}
output += " ";
var t_20;
t_20 = (runtime.contextOrFrameLookup(context, frame, "innerGroupHeightValue") - ((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "previousLineValue")),"value") / runtime.contextOrFrameLookup(context, frame, "maxValue")) * runtime.contextOrFrameLookup(context, frame, "innerGroupHeightValue")));
frame.set("yPreviousValue", t_20, true);
if(frame.topLevel) {
context.setVariable("yPreviousValue", t_20);
}
if(frame.topLevel) {
context.addExport("yPreviousValue", t_20);
}
output += " ";
var t_21;
t_21 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.contextOrFrameLookup(context, frame, "valueCode"))),"line_color");
frame.set("lineColor", t_21, true);
if(frame.topLevel) {
context.setVariable("lineColor", t_21);
}
if(frame.topLevel) {
context.addExport("lineColor", t_21);
}
output += " ";
var t_22;
t_22 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.contextOrFrameLookup(context, frame, "valueCode"))),"stroke_width");
frame.set("strokeWidth", t_22, true);
if(frame.topLevel) {
context.setVariable("strokeWidth", t_22);
}
if(frame.topLevel) {
context.addExport("strokeWidth", t_22);
}
output += " ";
var t_23;
t_23 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.contextOrFrameLookup(context, frame, "valueCode"))),"dashed");
frame.set("isDashed", t_23, true);
if(frame.topLevel) {
context.setVariable("isDashed", t_23);
}
if(frame.topLevel) {
context.addExport("isDashed", t_23);
}
output += " <path fill=\"none\" stroke=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "lineColor"), env.opts.autoescape);
output += "\" stroke-width=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "strokeWidth") || "3", env.opts.autoescape);
output += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "isDashed")) {
output += " stroke-dasharray=\"10,10\" ";
;
}
output += " d=\"M ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "xPreviousValue"), env.opts.autoescape);
output += ",";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "yPreviousValue"), env.opts.autoescape);
output += " L ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "xValue"), env.opts.autoescape);
output += ",";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "yValue"), env.opts.autoescape);
output += "\"></path> ";
;
}
output += " ";
if(runtime.contextOrFrameLookup(context, frame, "groupIndex") != (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"columns")),"length") - 1) && !runtime.memberLookup((t_10),"hideNextPath")) {
output += " ";
var t_24;
t_24 = (runtime.contextOrFrameLookup(context, frame, "groupIndex") + 1);
frame.set("nextIndex", t_24, true);
if(frame.topLevel) {
context.setVariable("nextIndex", t_24);
}
if(frame.topLevel) {
context.addExport("nextIndex", t_24);
}
output += " ";
var t_25;
t_25 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_4),"values")),runtime.contextOrFrameLookup(context, frame, "nextIndex"))),"v")),0);
frame.set("nextLineValue", t_25, true);
if(frame.topLevel) {
context.setVariable("nextLineValue", t_25);
}
if(frame.topLevel) {
context.addExport("nextLineValue", t_25);
}
output += " ";
var t_26;
t_26 = (runtime.contextOrFrameLookup(context, frame, "xValue") + runtime.contextOrFrameLookup(context, frame, "groupWidthValue"));
frame.set("xNextValue", t_26, true);
if(frame.topLevel) {
context.setVariable("xNextValue", t_26);
}
if(frame.topLevel) {
context.addExport("xNextValue", t_26);
}
output += " ";
var t_27;
t_27 = (runtime.contextOrFrameLookup(context, frame, "innerGroupHeightValue") - ((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "nextLineValue")),"value") / runtime.contextOrFrameLookup(context, frame, "maxValue")) * runtime.contextOrFrameLookup(context, frame, "innerGroupHeightValue")));
frame.set("yNextValue", t_27, true);
if(frame.topLevel) {
context.setVariable("yNextValue", t_27);
}
if(frame.topLevel) {
context.addExport("yNextValue", t_27);
}
output += " ";
var t_28;
t_28 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.contextOrFrameLookup(context, frame, "valueCode"))),"line_color");
frame.set("lineColor", t_28, true);
if(frame.topLevel) {
context.setVariable("lineColor", t_28);
}
if(frame.topLevel) {
context.addExport("lineColor", t_28);
}
output += " ";
var t_29;
t_29 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.contextOrFrameLookup(context, frame, "valueCode"))),"stroke_width");
frame.set("strokeWidth", t_29, true);
if(frame.topLevel) {
context.setVariable("strokeWidth", t_29);
}
if(frame.topLevel) {
context.addExport("strokeWidth", t_29);
}
output += " ";
var t_30;
t_30 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"chartData")),"values_map")),runtime.contextOrFrameLookup(context, frame, "valueCode"))),"dashed");
frame.set("isDashed", t_30, true);
if(frame.topLevel) {
context.setVariable("isDashed", t_30);
}
if(frame.topLevel) {
context.addExport("isDashed", t_30);
}
output += " <path fill=\"none\" stroke=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "lineColor"), env.opts.autoescape);
output += "\" stroke-width=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "strokeWidth") || "3", env.opts.autoescape);
output += "\" ";
if(runtime.contextOrFrameLookup(context, frame, "isDashed")) {
output += " stroke-dasharray=\"10,10\" ";
;
}
output += " d=\"M ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "xNextValue"), env.opts.autoescape);
output += ",";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "yNextValue"), env.opts.autoescape);
output += " L ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "xValue"), env.opts.autoescape);
output += ",";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "yValue"), env.opts.autoescape);
output += "\"></path> ";
;
}
output += " ";
if(!runtime.memberLookup((t_10),"hideCircle")) {
output += " <circle r=\"6\" cx=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "xValue"), env.opts.autoescape);
output += "\" cy=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "yValue"), env.opts.autoescape);
output += "\" fill=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "circleColor"), env.opts.autoescape);
output += "\" stroke=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "circleStroke"), env.opts.autoescape);
output += "\" stroke-width=\"2\"></circle> ";
;
}
output += " ";
;
}
}
frame = frame.pop();
output += " ";
;
}
}
frame = frame.pop();
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
